/*
 * PlanPage Messages
 *
 * This contains all the text for the PlanPage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  mainDescription: {
    id: 'cwt.translations.PlanPage.MainShape.Description',
    defaultMessage: 'Choose the shape that best suits how you use your kitchen. Fill in your measurements. If you don’t have your exact measurements now, you can estimate.',
  },
  wallLocationDescription: {
    id: 'cwt.translations.PlanPage.WallLocation.Description',
    defaultMessage: 'Select which sides of your worktop will sit against a wall here.',
  },
  adjoiningHighCabinetDescription: {
    id: 'cwt.translations.PlanPage.AdjoiningHighCabinet.Description',
    defaultMessage: 'Adjoining high cabinets requires a straight edge regardless on selected worktop edge.',
  },
  overhangTypeDescription: {
    id: 'cwt.translations.PlanPage.OverhangType.Description',
    defaultMessage: 'You can create a bar solution by extending the worktop, then choose from different supports.',
  },
  overhangSideDescription: {
    id: 'cwt.translations.PlanPage.OverhangSide.Description',
    defaultMessage: 'Select on which side or sides you want your overhang and enter the desired length.',
  },
  errorInvalidCombination: {
    id: 'cwt.translations.PlanPage.Error.InvalidCombination',
    defaultMessage: 'Invalid combination',
  },
  errorMinimum: {
    id: 'cwt.translations.PlanPage.Error.Minimum',
    defaultMessage: 'Minimum {{value, number}} mm',
  },
  errorMaximum: {
    id: 'cwt.translations.PlanPage.Error.Maximum',
    defaultMessage: 'Maximum {{value, number}} mm',
  },
  errorMinimumImperial: {
    id: 'cwt.translations.PlanPage.Error.MinimumImperial',
    defaultMessage: 'Minimum {{value, number}} inches',
  },
  errorMaximumImperial: {
    id: 'cwt.translations.PlanPage.Error.MaximumImperial',
    defaultMessage: 'Maximum {{value, number}} inches',
  },
  errorOverhangMaximum: {
    id: 'cwt.translations.PlanPage.Error.OverhangMaximum',
    defaultMessage: 'Worktop + overhang cannot exceed {{value, number}} mm',
  },
  errorOverhangMaximumImperial: {
    id: 'cwt.translations.PlanPage.Error.OverhangMaximumImperial',
    defaultMessage: 'Worktop + overhang cannot exceed {{value, number}} inches',
  },
  didYouKnowSubtitle: {
    id: 'cwt.translations.DidYouKnow.CutOuts.Subtitle',
    defaultMessage: 'Cut-outs',
  },
  didYouKnowDescription: {
    id: 'cwt.translations.DidYouKnow.Cutouts.Description',
    defaultMessage: 'Need a rounded corner? How about a cut-out for a hob? Our custom worktops give you the flexibility to add cut-outs to suit your space and your style.',
  },
  sinkRequiredDepth: {
    id: 'cwt.translations.PlanPage.Error.SinkRequires',
    defaultMessage: 'Required depth = {{depth, number}} mm',
  },
  sinkMinimumLength: {
    id: 'cwt.translations.PlanPage.Error.SinkMinimum',
    defaultMessage: 'Required length ≥ {{length, number}} mm',
  },
  sinkRequiredDepthImperial: {
    id: 'cwt.translations.PlanPage.Error.SinkRequiresImperial',
    defaultMessage: 'Required depth =  {{depth, number}} inches',
  },
  sinkMinimumLengthImperial: {
    id: 'cwt.translations.PlanPage.Error.SinkMinimumImperial',
    defaultMessage: 'Required length ≥ {{length, number}} inches',
  },
  lengthExcludingCorners: {
    id: 'cwt.translations.PlanPage.Error.lengthExcludingCorners',
    defaultMessage: 'excluding corners',
  },
  showMore: {
    id: 'cwt.translations.PlanPage.ShowMore',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'cwt.translations.PlanPage.ShowLess',
    defaultMessage: 'Show less',
  },
  errorFreestandingHob: {
    id: 'cwt.translations.PlanPage.freestandingHob',
    defaultMessage: 'Cooker width can not exceed worktop length',
  },
  overhangLegRequirement: {
    id: 'cwt.translations.PlanPage.OverhangLegRequirement',
    defaultMessage: 'You will need a supporting leg (sold separately) for overhangs that exceed {{first, number}} mm, and for every additional {{repeat, number}} mm.',
  },
  overhangLegRequirementImperial: {
    id: 'cwt.translations.PlanPage.OverhangLegRequirementImperial',
    defaultMessage: 'You will need a supporting leg (sold separately) for overhangs that exceed {{first, number}} inches, and for every additional {{repeat, number}} inches.',
  },
});
